import { ViewChild, Renderer2, Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from '../../../../core/services/app.service';
import { LoginService } from '../../../../core/services/login.service';
import { DatePipe, CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, MatSidenavModule, MatListModule, MatIconModule, MatToolbarModule, MatDividerModule, MatTooltipModule, TranslateModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass'],
  providers: [DatePipe]
})

export class SidebarComponent implements OnInit 
{
  @ViewChild('navIcon') navIcon: ElementRef;
  @ViewChild('sidebar') sidebar: ElementRef;
  selected: string;
  expandUsage: string = '+';
  search: any;
  menu: any = [];
  adminMenu: any = [];
  certsMenu: any = [];
  name: string = '';
  lastAccess: string = '';
  hasChilds: boolean = false;
  closeChild: boolean = true;
  opened: boolean = true; // or false, depending on your default state
  
  constructor(
    private appComponent: AppComponent,
    private router: Router,
    private dialog: MatDialog,
    public appService: AppService,
    public loginService: LoginService,
    private renderer: Renderer2,
    private datePipe: DatePipe) { }

  ngOnInit(): void 
  {
    if (this.appService.userInfo != undefined) 
    { 
      this.name = this.appService.userInfo.userid; 
      this.lastAccess = this.datePipe.transform(this.appService.userInfo.lastaccess, 'dd/MM/yyyy HH:mm:ss') || ''; 
    }

    this.appService.getUserMenu(this.appService.userInfo.rolesid).subscribe(result => 
    {
      this.menu = result;
      this.menu.forEach(element => 
      {
        if (element.name != "Home" && element.name.includes('Certificates')) { this.certsMenu.push(element) }
        else if (element.name != "Home" && !element.name.includes('Certificates')) { this.adminMenu.push(element) }
      });
    });
  }

  initPage(myPage) 
  {
    if (myPage === 'usageDetail' || myPage === 'usagePattern') 
    {
      this.hasChilds = true;
      this.isSelected('usage');
    } 
    else if (myPage !== null && myPage !== undefined) 
    {
      this.hasChilds = false;
      if (this.selected === undefined) { this.selected = myPage; }
      if (this.selected == null || this.selected === '') 
      {
        this.selected = 'home';
        this.isSelected('home');
      } 
      else { this.isSelected(myPage); }
    } 
    else { this.hasChilds = false; }
  }

  toggle() 
  {
    const contentBody = document.body.querySelector('.contentBody');
    if (this.navIcon.nativeElement.className === 'open') { this.close();} 
    else 
    {
      this.navIcon.nativeElement.className = 'open';
      this.sidebar.nativeElement.className = 'expanded';
      this.renderer.setAttribute(contentBody, 'style', 'transform: translate(250px); padding: 0;');
      this.appComponent.toggle();
    }
  }

  close() 
  {
    const contentBody = document.body.querySelector('.contentBody');
    this.navIcon.nativeElement.className = '';
    this.sidebar.nativeElement.className = 'collapsed';
    this.renderer.setAttribute(contentBody, 'style', '');
    this.closeChild = true;
    this.expandUsage = '+';
    this.appComponent.close();
  }

  isSelected(item: string) 
  {
    if (item !== 'login') 
    {
      const lastItem = document.body.querySelector('#' + this.selected);
      const newItem = document.body.querySelector('#' + item);
      if (lastItem !== null) { lastItem.className = ''; }
      if (newItem !== null) 
      {
        if (item === 'usage' && this.hasChilds) { newItem.className = 'selected hasChilds'; } 
        else { newItem.className = 'selected'; }
      }
    }
    this.selected = item;
  }
  async logOut() 
  {
    this.appService.saveInLocal(environment.userStorage, null);
    this.dialog.closeAll();
    this.appService.checkLogged();
    this.appService.hideContent(true);
    this.loginService.logout().subscribe(pathlogin => 
    { 
      localStorage.removeItem('tokenOAuth');
      this.appService.tokenOAuth = "";
      window.location.href = pathlogin.url;
    });
  }

  userProfile() { this.close(); this.router.navigate(['/userProfile']); }

  home() { this.close(); this.router.navigate(['/home']); }

  goToMenu(menu: any) 
  {
    if (this.navIcon.nativeElement.className === 'open') { this.close(); }
    if (menu.link !== '') { this.router.navigate([menu.link]); }
  }

  getImg(icon: string) 
  {
    if (icon.split(' ')[0]) { return `./assets/icons/${icon.split(' ')[0]}-white.png`; }
    return '';
  }

}